import type { Teammate } from "@repo/app-types/entities/teammate";
import type { FC } from "react";

import { IconExternalLink } from "@tabler/icons-react";
import { TeammateAvatar } from "../../teammate/teammateAvatar.js";

interface HighlightMomentCardProps {
  readonly teammate: Teammate | undefined;
  readonly teammateName: string;
  readonly quote: string;
  readonly gradingUrl: string;
}

const stripQuotes = (text: string): string =>
  text.replace(
    /^[\s"'"'\u201C\u201D\u2018\u2019]+|[\s"'"'\u201C\u201D\u2018\u2019]+$/g,
    "",
  );

export const HighlightMomentCard: FC<HighlightMomentCardProps> = ({
  teammate,
  teammateName,
  quote,
  gradingUrl,
}) => (
  <a
    href={gradingUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative flex h-full flex-col justify-between rounded-md bg-white px-5 pt-5 pb-4 shadow-sm ring-1 ring-black/5 transition hover:bg-slate-50"
  >
    <div>
      <span className="text-3xl leading-none text-amber-300">&ldquo;</span>
      <p className="text-sm leading-relaxed text-foreground italic">
        {stripQuotes(quote)}
      </p>
    </div>
    <div className="mt-4 flex items-center gap-2">
      <TeammateAvatar teammate={teammate} />
      <span className="truncate text-sm font-medium text-foreground">
        {teammateName}
      </span>
    </div>
    <IconExternalLink className="pointer-events-none absolute right-3 bottom-3 size-4 text-slate-400 opacity-0 transition-opacity group-hover:opacity-100" />
  </a>
);
